module.exports = __webpack_public_path__ + "img/xjsk.ec5e4ad8.png";